import { ConnectionQualityLevel } from 'utils/webrtc/ConnectionQuality';
import { findWorstTrack } from 'utils/webrtc/stats/aggregators';
import { logBucketTransition } from 'utils/webrtc/stats/stats-logger';
import { AggregateScores, TrackScore } from 'utils/webrtc/stats/types';

const bucketLabel = (level: ConnectionQualityLevel): 'good' | 'fair' | 'poor' => {
  if (level === ConnectionQualityLevel.good) {
    return 'good';
  }
  if (level === ConnectionQualityLevel.fair) {
    return 'fair';
  }
  return 'poor';
};

// Emits webrtc-scores:bucket events on quality-level transitions; holds previous level between ticks.
export class BucketTransitionEmitter {
  private previousBucketLevel?: ConnectionQualityLevel;

  observe(
    aggregate: AggregateScores,
    allScores: readonly TrackScore[],
    currentLevel: ConnectionQualityLevel | null
  ): void {
    // A measurement gap breaks continuity — without resetting, the next live
    // observation would log a transition that spans the empty window.
    if (aggregate.aggregateMOSMedianReceiving === null || currentLevel === null) {
      this.previousBucketLevel = undefined;
      return;
    }
    if (this.previousBucketLevel !== undefined && currentLevel !== this.previousBucketLevel) {
      logBucketTransition({
        from: bucketLabel(this.previousBucketLevel),
        to: bucketLabel(currentLevel),
        aggregateMOS: aggregate.aggregateMOSMedianReceiving,
        worstAudio: aggregate.worstAudio,
        worstVideo: aggregate.worstVideo,
        worstTrack: findWorstTrack(allScores),
      });
    }
    this.previousBucketLevel = currentLevel;
  }

  reset(): void {
    this.previousBucketLevel = undefined;
  }
}
